<template>
  <div class="form-container">
  <el-input
    v-model="searchQuery"
    placeholder="搜索订单"
    clearable
    style="width: 300px; margin-right: 10px;"
    @input="handleSearch"
  />
  <el-date-picker
    v-model="orderTime"
    type="date"
    placeholder="选择日期"
    :default-value="new Date()"
    @change="handleSearch"
    style="width: 200px; margin-right: 10px;"
  />
  <el-select
    v-model="selectedOptions"
    placeholder="请选择客户"
    style="width: 150px; margin-right: 10px;"
    @change="handleSearch"
  >
    <el-option value="" label="请选择客户"></el-option>
    <el-option
      v-for="user in users"
      :key="user.name"
      :label="user.name"
      :value="user.id"
    />
  </el-select>
  <el-select
    v-model="selectedStatus"
    placeholder="请选择订单状态"
    style="width: 150px; margin-right: 10px;"
    @change="handleSearch"
  >
    <el-option value="" label="请选择订单状态"></el-option>
    <el-option
      v-for="status in statusOptions"
      :key="status.value"
      :label="status.label"
      :value="status.value"
    />
  </el-select>
  <el-button
    type="primary"
    @click="addDialogVisible = true"
    size="medium"
  >
    <el-icon><Plus /></el-icon> 添加订单
  </el-button>
</div>


 <el-table
  :data="filteredOrders"
  style="width: 100%"
  stripe
  border
  highlight-current-row
>
  <el-table-column prop="id" label="ID" width="100" align="center"></el-table-column>
  <el-table-column prop="username" label="用户名" width="120" align="center">
    <template #default="scope">
      {{ scope.row.user || '—' }}
    </template>
  </el-table-column>
  <el-table-column prop="orderNumber" label="订单号" width="150" align="center"></el-table-column>
  <el-table-column label="订单内容" width="300" align="center">
    <template #default="scope">
      <div class="order-content">
        <div v-for="(line, index) in formattedLines(scope.row.orderContent)" :key="index">
          <a
            v-if="isLinkableLine(line, index, scope.row.options)"
            :href="generateLink(line)"
            target="_blank"
            class="link-style"
          >
            {{ line }}
          </a>
          <span v-else>{{ line }}</span>
        </div>
      </div>
    </template>
  </el-table-column>
  <el-table-column prop="orderTime" label="下单时间" width="150" align="center"></el-table-column>
  <el-table-column prop="sellPrice" label="平仓价" width="120" align="center">
    <template #default="scope">
      {{ scope.row.sellPrice === 0 ? '—' : scope.row.sellPrice }}
    </template>
  </el-table-column>
  <el-table-column prop="customer" label="客户" width="120" align="center">
    <template #default="scope">
      {{ scope.row.customer || '—' }}
    </template>
  </el-table-column>
  <el-table-column prop="options" label="期权公司" width="120" align="center">
    <template #default="scope">
      {{ scope.row.options || '—' }}
    </template>
  </el-table-column>
  <el-table-column prop="endTime" label="到期日期" width="120" align="center">
    <template #default="scope">
      {{ scope.row.endTime || '—' }}
    </template>
  </el-table-column>
  <el-table-column prop="status" label="状态" width="100" align="center">
    <template #default="scope">
      <el-switch
        v-model="scope.row.status"
        :active-value="1"
        :inactive-value="0"
        active-color="#13ce66"
        inactive-color="#ff4949"
        @change="handleStatusChange(scope.row)"
      />
    </template>
  </el-table-column>
  <el-table-column label="操作" width="220" align="center">
   <template #default="scope">

            <el-button
              @click="convertToTable(scope.$index, scope.row)"
              size="small"
              type="primary"
              plain
            >
              <el-icon><Document /></el-icon> 回执单
            </el-button>
            <el-button
              @click="showCalculation(scope.$index, scope.row)"
              size="small"
              type="success"
              plain
            >
              <el-icon><Calculator /></el-icon> 收益
            </el-button>
            <el-button
              @click="sellOrder(scope.$index, scope.row)"
              size="small"
              type="warning"
              plain
            >
              <el-icon><Edit /></el-icon> 平仓
            </el-button>
            <el-button
              @click="editOrder(scope.$index, scope.row)"
              size="small"
              type="info"
              plain
            >
              <el-icon><Edit /></el-icon> 编辑
            </el-button>
            <el-button
              @click="deleteOrder(scope.$index, scope.row)"
              size="small"
              type="danger"
              plain
            >
              <el-icon><Delete /></el-icon> 删除
            </el-button>

        </template>

  </el-table-column>
</el-table>


  <div class="pagination-container">
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      style="margin-top: 20px; text-align: right;"
    />
  </div>

  <el-dialog title="添加订单" v-model="addDialogVisible" width="50%" center>
  <el-form :model="newOrder" label-width="100px">
    <el-form-item label="订单编号">
      <el-input v-model="newOrder.orderNumber" type="input" />
    </el-form-item>
    <el-form-item label="标的代码">
      <el-input v-model="newOrder.stock_code" type="input" />
    </el-form-item>
       <el-form-item label="标的名称">
      <el-input v-model="newOrder.stock_name" type="input" />
    </el-form-item>

    <el-form-item label="期限">

       <el-select v-model="newOrder.month" placeholder="请选择期限" style="width: 100%;">
        <el-option value="" label="请选择机构" disabled></el-option>
        <el-option
          v-for="month in months_options"
          :key="month.key"
          :label="month.value"
          :value="month.key"
        />
      </el-select>
    </el-form-item>

     <el-form-item label="期权费率">
      <el-input v-model="newOrder.rate" type="input" />
    </el-form-item>
    <el-form-item label="总费用">
      <el-input v-model="newOrder.total_price" type="input" />
    </el-form-item>
     <el-form-item label="期权类型">
        <el-select v-model="newOrder.types" placeholder="请选择期权类型" style="width: 100%;">
        <el-option value="" label="请选择期权类型" disabled></el-option>
        <el-option
          v-for="type in types_options"
          :key="type.key"
          :label="type.value"
          :value="type.key"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="名本规模">
        <el-select v-model="newOrder.size" placeholder="请选择期限" style="width: 100%;">
        <el-option value="" label="请选择机构" disabled></el-option>
        <el-option
          v-for="size in size_options"
          :key="size.key"
          :label="size.value"
          :value="size.key"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="开仓价">
      <el-input v-model="newOrder.open_price" type="input" />
    </el-form-item>

    <el-form-item label="起始日">
        <el-input
        v-model="newOrder.startTime"
        placeholder="到期时间"
        clearable
        type="date"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        style="width: 300px;"
      />
    </el-form-item>
  <el-form-item label="到期日">

          <el-input
        v-model="newOrder.endTime"
        placeholder="到期时间"
        clearable
        type="date"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        style="width: 300px;"
      />

    </el-form-item>
    <el-form-item label="机构">
      <el-select v-model="newOrder.options" placeholder="请选择机构" style="width: 100%;">
        <el-option value="" label="请选择机构" disabled></el-option>
        <el-option
          v-for="brokerage in brokerage_options"
          :key="brokerage.key"
          :label="brokerage.value"
          :value="brokerage.key"
        />
      </el-select>
    </el-form-item>
     <el-form-item label="客户">
      <el-select v-model="newOrder.customerId" placeholder="客户" style="width: 100%;">
        <el-option value="" label="客户" disabled></el-option>
        <el-option
          v-for="user in users"
          :key="user.name"
          :label="user.name"
          :value="user.id"
        />
      </el-select>
       </el-form-item>
    <el-form-item label="订单内容">
      <el-input v-model="newOrder.orderContent" type="textarea" :rows="5"></el-input>
    </el-form-item>
  </el-form>
  <template #footer>
    <span class="dialog-footer">
      <el-button @click="addDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleAdd">确定</el-button>
    </span>
  </template>
</el-dialog>


<!-- 编辑订单弹窗 -->
<el-dialog title="编辑订单" v-model="editDialogVisible" width="50%">
  <el-form :model="newOrder" label-width="100px">
  <el-form-item label="订单编号">
      <el-input v-model="newOrder.orderNumber" type="input" />
    </el-form-item>
    <el-form-item label="标的代码">
      <el-input v-model="newOrder.stock_code" type="input" />
    </el-form-item>
    <el-form-item label="标的名称">
      <el-input v-model="newOrder.stock_name" type="input" />
    </el-form-item>
    <el-form-item label="机构">
      <el-select v-model="newOrder.options" placeholder="请选择机构">
        <el-option value="" label="请选择机构" disabled></el-option>
        <el-option
          v-for="brokerage in brokerage_options"
          :key="brokerage.key"
          :label="brokerage.value"
          :value="brokerage.key"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="期限">
      <el-select v-model="newOrder.month" placeholder="请选择期限">
        <el-option value="" label="请选择期限" disabled></el-option>
        <el-option
          v-for="month in months_options"
          :key="month.key"
          :label="month.value"
          :value="month.key"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="期权类型">
      <el-select v-model="newOrder.types" placeholder="请选择期权类型">
        <el-option value="" label="请选择期权类型" disabled></el-option>
        <el-option
          v-for="type in types_options"
          :key="type.key"
          :label="type.value"
          :value="type.key"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="名本规模">
      <el-select v-model="newOrder.size" placeholder="请选择名本规模">
        <el-option value="" label="请选择名本规模" disabled></el-option>
        <el-option
          v-for="size in size_options"
          :key="size.key"
          :label="size.value"
          :value="size.key"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="开仓价">
      <el-input v-model="newOrder.open_price" type="input" />
    </el-form-item>

    <el-form-item label="期权费率">
      <el-input v-model="newOrder.rate" type="input" />
    </el-form-item>

    <el-form-item label="总费用">
      <el-input v-model="newOrder.total_price" type="input" />
    </el-form-item>

    <el-form-item label="起始日">

       <el-input
        v-model="newOrder.startTime"
        placeholder="到期时间"
        clearable
        type="date"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        style="width: 300px;"
      />
    </el-form-item>

    <el-form-item label="到期时间">
      <el-input
        v-model="newOrder.endTime"
        placeholder="到期时间"
        clearable
        type="date"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        style="width: 300px;"
      />
    </el-form-item>

    <el-form-item label="平仓价">
      <el-input-number v-model="newOrder.sellPrice" :precision="4"></el-input-number>
    </el-form-item>

    <el-form-item label="客户">
      <el-select v-model="newOrder.customerId" placeholder="请选择客户">
        <el-option value="" label="请选择客户" disabled></el-option>
        <el-option
          v-for="user in users"
          :key="user.id"
          :label="user.name"
          :value="user.id"
        />
      </el-select>
    </el-form-item>

    <el-form-item prop="status" label="状态" width="120">
      <el-switch
        v-model="newOrder.status"
        :active-value="1"
        :inactive-value="0"
        active-color="#13ce66"
        inactive-color="#ff4949"
      />
    </el-form-item>
        <el-form-item label="订单内容">
      <el-input v-model="newOrder.orderContent" type="textarea" :rows="5"></el-input>
    </el-form-item>
  </el-form>
  <template #footer>
    <span class="dialog-footer">
      <el-button @click="editDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleUpdate">确定</el-button>
    </span>
  </template>
</el-dialog>


 <!-- 在回执单弹窗模板中修改 -->
<el-dialog title="回执单" v-model="showReceiptDialog" width="33%">
  <div class="table-container" v-if="tableData">
    <table class="styled-table">
      <tbody>
        <tr
          v-for="(row, index) in tableData"
          :key="index"
          :style="{ backgroundColor: index % 2 === 0 ? '#4f81bd' : '#9bbb59' }"
        >
          <td>{{ row[0] }}</td>
          <td>{{ row[1] }}</td>
        </tr>


        <tr
          :style="{ backgroundColor: (tableData.length + 2) % 2 === 0 ? '#4f81bd' : '#9bbb59' }"
        >
          <td>敲出规则</td>
          <td>连续三个涨跌停板则敲出</td>
        </tr>
        <tr
          :style="{ backgroundColor: (tableData.length + 3) % 1 === 0 ? '#4f81bd' : '#9bbb59' }"
        >
          <td>最快行权日</td>
          <td>T+1</td>
        </tr>
      </tbody>
    </table>
    <el-button @click="copyTableToImage" class="copy-button" size="medium">
      <el-icon><CopyDocument /></el-icon> 复制回执单
    </el-button>
  </div>
</el-dialog>


  <!-- 收益计算弹窗 -->
  <el-dialog title="收益计算" v-model="showCalculationDialog" width="33%">
    <CalculationTab :stockHandler="stockData" :calculationCallback="calculate" />
  </el-dialog>
</template>

<script>
import {
  ElTable,
  ElTableColumn,
  ElForm,
  ElFormItem,
  ElInput,
  ElButton,

  ElDialog,
  ElIcon,
  Plus,
  Document,
  Calculator,
  Edit,
  Delete,
  CopyDocument,
  ElInputNumber,

} from 'element-plus';
import axios from 'axios';
import CalculationTab from '@/components/CalculationTab.vue';
import { formatDate } from '@/utils/commonMethods';
import { copyTableToImage } from '@/utils/utils';
import { ElMessage } from "element-plus";
ElTable.props.fit.default = false;

export default {
  components: {
    CalculationTab,
    ElTable,
    ElTableColumn,
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,

    ElDialog,
    ElIcon,
    Plus,
    Document,
    Calculator,
    Edit,
    Delete,
    CopyDocument,
    ElInputNumber




  },
  data() {
    return {
      orderTime: '',
      searchQuery: '',
      orders: [],
      filteredOrders: [],
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50],
      total: 0,
      newOrder: {
        uid: '',
        orderNumber: '',
        orderContent: '',
        orderTime: '',
        sellPrice: 0.0,
        status: 0,
        options :'',
        endTime: '',
        size: '100M',
        month: '1M',
        open_price :'',
        customerId: "",
        rate: 0.0,
        types: '',
        total_price: '',
        stock_code: '',
        stock_name: '',
        startTime: '',
        brokerage: ''
      },
      currentEditIndex: -1,
      addDialogVisible: false,
      editDialogVisible: false,
      showReceiptDialog: false,
      selectedStatus:0,
      statusOptions: [ // 状态选项
          { value: 0, label: '进行中' },
          { value: 1, label: '已平仓' }
       ],
      brokerage_options: [
        { value: '银河', key: '银河' },
        { value: '华泰', key: '华泰' },
        { value: '中金', key: '中金' },
        { value: '中信中证', key: '中信中证' },
        { value: '永安', key: '永安' },
        { value: '浙期', key: '浙期' },
        { value: '国君', key: '国君' },
        { value: '国君', key: '广发' }
      ],
       months_options: [
        { value: '2W', key: '2W' },
        { value: '1M', key: '1M' },
        { value: '2M', key: '2M' },
        { value: '3M', key: '3M' },
        { value: '6M', key: '6M' },
        { value: '12M', key: '12M' }
      ],

       size_options: [
        { value: '100M', key: '100M' },
        { value: '200M', key: '200M' },
        { value: '300M', key: '300M' },
        { value: '400M', key: '400M' },
        { value: '500M', key: '500M' }
      ],
       types_options: [
        { value: '100%看涨', key: '100%看涨' },
        { value: '100%看跌', key: '100%看跌' },
      ],

      showCalculationDialog: false,
      tableData: [],
      stockData: [],
      users: [], // 添加用户列表
    };
  },
  created() {
    this.fetchCustomers();
    this.handleSearch(); // 👈 初始化时触发搜索
  },
   computed: {
    formattedDate() {
      return this.orderTime ? formatDate(this.orderTime) : '';
    },
  },
  methods: {
      orderLines() {
        return (content) => {
          return content
            .replace(/\\n/g, '\n') // 解析转义换行符
            .split('\n')
            .map(line => line.trim()) // 去除首尾空格
        }
      },

    formattedLines(content) { // 修正方法名
        return content
          .replace(/\\n/g, '\n') // 解析转义换行符
          .split('\n')
          .map(line => line.trim()) // 去除首尾空格
      },
       // 新增配置映射
        getValidIndices(options) {
          return {
            '华泰': [0, 1],
            '银河': [2, 3],
            '永安': [2, 3],
            '中信中证': [2, 3],
            '浙期': [2, 3]
            // 可添加其他机构配置
          }[options] || []
        },
       // 修改后的判断方法
        isLinkableLine(line, index, options) {
          const validIndices = this.getValidIndices(options);
          return (
            validIndices.includes(index) &&
            line.includes(' ') &&
            line.split(' ')[1]
          );
        },

      // 生成带编码的URL
      generateLink(line) {
        const code = line.split(' ')[1]
        return `https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${encodeURIComponent(code)}`
      },
     copyTableToImage() {
      const table = document.querySelector('.styled-table');
      const firstRow = table.rows[1];
      const thirdCell = firstRow.cells[2];
      const fileName = '个股【'+thirdCell+'】期权查询情况_' + this.currentDate + '.png';
      copyTableToImage(table, fileName);
    },
    handleStatusChange(row) {
      const status = row.status
      console.log('Status changed to:', status);
      axios
        .put(`/api/orders/${row.id}`, { status: status }, {
          headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
        })
        .then(() => {
          this.$message.success('状态更新成功');
        })
        .catch((error) => {
          this.$message.error('状态更新失败');
          row.status = !row.status; // 回滚状态
          console.error('状态更新失败:', error);
        });
    },
   convertToTable(index, row) {
  // 将 tableData 改为二维数组格式
  this.tableData = [
    ['标的代码', row.stock_code],
    ['标的名称', row.stock_name],
    ['期限', row.month],
    ['期权类型', row.types],
    ['期权费率', row.rate+'%'],
    ['名本规模', row.size],
    ['开仓时间', row.startTime],
    ['到期时间', row.endTime],
    ['开仓价', row.open_price],
    ['行权价', row.open_price],
    ['合计费用', row.total_price],

  ];

  console.log('Table data:', this.tableData);
  this.showReceiptDialog = true;
},

   sellOrder(index, row) {
      const clonedRow = JSON.parse(JSON.stringify(row));
      clonedRow.orderContent = clonedRow.orderContent.replace(/\\n/g, '\n');
      const data = clonedRow.orderContent.split('\n');

      // 验证数据有效性（可选）
      if (!data[1] || !data[2] || !data[3] || !data[8] || !data[13]) {
        this.$message.error('订单数据不完整，无法复制');
        return;
      }

      // 生成文本内容
      let text =
        "标的：" + data[2].split(': ')[1] + " " + data[3].split(': ')[1] + "\n" +
        "期初：" + data[13].split(': ')[1] + "\n" +
        "名本：100M\n" +
        "限价：市价/限价元\n"+
        "行权：平仓"
      // 复制到剪贴板
      navigator.clipboard.writeText(text)
        .then(() => {
          this.$message.success('内容已复制到剪贴板');
        })
        .catch((error) => {
          console.error('复制失败:', error);
          this.$message.error('复制失败，请检查权限');
        });
    },

    showCalculation(index, row) {
      const clonedRow = JSON.parse(JSON.stringify(row));
      clonedRow.orderContent = clonedRow.orderContent.replace(/\\n/g, '\n');
      const data = clonedRow.orderContent.split('\n');
      this.stockData = {
        code: `${data[3].split(': ')[1]} ${data[2].split(': ')[1]}`,
        buyPrice: data[13].split(': ')[1],
        sellPrice: clonedRow.sellPrice,
        optionRate: data[7].split(': ')[1].replace('%', ''),
        knockOutPrice: data[13],
      };
      this.showCalculationDialog = true;
    },
    calculate(
      formattedBuyPrice,
      formattedSellPrice,
      formattedOptionRate,
      formattedKnockOutPrice
    ) {
      const BuyPrice = formattedBuyPrice;
      const SellPrice = formattedSellPrice;
      const OptionRate = formattedOptionRate;
      const KnockOutPrice = formattedKnockOutPrice;
      const total = 1000000;
      const fee = 0.01;
      const fee_total = 0.2;
      const fee_amount = ((fee * OptionRate * total) + fee_total).toFixed(2);
      const amount = (SellPrice - BuyPrice) / BuyPrice;

      const earnings = (amount * total).toFixed(2);
      const profit = (earnings - fee_amount).toFixed(2);
      const funds_fee = ((profit / fee_amount) * 100).toFixed(2);

      const knock_out_earnings = (
        (KnockOutPrice - BuyPrice) / BuyPrice * total
      ).toFixed(2);
      const knock_out_profit = (
        knock_out_earnings - fee_amount
      ).toFixed(2);
      const knock_out_funds_fee = (
        (knock_out_profit / fee_amount) * 100
      ).toFixed(2);

      const js = (1 + (parseFloat(OptionRate) + parseFloat(fee_total)) / 100) * BuyPrice;
      return [
        {
          "持仓成本": (fee_amount / 10000).toFixed(2) + "万元",
          "持仓股数": (total / BuyPrice).toFixed(2),
          "回本价格": js.toFixed(2) + "元",
          "标的涨幅": (amount * 100).toFixed(2) + "%",
        },
        {
          "期末收益": (earnings / 10000).toFixed(2) + "万元",
          "净收益": (profit / 10000).toFixed(2) + "万元",
          "收益率": funds_fee + "%",
        },
        {
          "敲出收益": (knock_out_earnings / 10000).toFixed(2) + "元",
          "敲出净收益": (knock_out_profit / 10000).toFixed(2) + "元",
          "敲出收益率": knock_out_funds_fee + "%",
        },
      ];
    },
   handleSearch() {
      this.currentPage = 1;
      this.fetchOrders();
    },

    fetchOrders() {
      axios
        .get('/api/orders', {
          headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
          params: {
              page: this.currentPage,
              page_size: this.pageSize,
              search:this.searchQuery,
              status:this.selectedStatus,
              customerId:this.selectedOptions,
              endTime:  this.formattedDate
          },
        })
        .then((response) => {
          this.filteredOrders=response.data.list || [];
          this.orders = response.data.list || [];
          this.total = response.data.total || 0;
        })
        .catch((error) => {
         if (error.response && error.response.data && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
             this.$message.error('获取订单失败');
          }
        });
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1;
      this.fetchOrders();
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.fetchOrders();
    },
    handleAdd() {
      axios
        .post('/api/orders', this.newOrder, {
          headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
        })
        .then(() => {
          this.$message.success('订单添加成功');
          this.fetchOrders();
          this.resetForm();
          this.addDialogVisible = false;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
             this.$message.error('添加订单失败');
          }
        });
    },
    editOrder(index, row) {
      this.currentEditIndex = index;
      this.newOrder = { ...row };
      console.log(row);
      this.newOrder.options = row.options || '';
      this.newOrder.endTime = row.endTime || '';
      this.newOrder.orderTime = this.newOrder.orderTime || '';
      this.newOrder.status=this.newOrder.status || 0;
      this.newOrder.customerId = row.customerId || '';
      this.newOrder.orderContent = row.orderContent || '';
      this.newOrder.sellPrice = row.sellPrice || '';
      this.newOrder.orderNumber = row.orderNumber || '';
      this.newOrder.uid = row.uid || '';
      this.newOrder.id = row.id || '';
      this.newOrder.orderContent = row.orderContent || '';
      this.newOrder.types = row.types || '';
      this.newOrder.size = row.size || '';
      this.newOrder.rate = row.rate || '';
      this.newOrder.open_price = row.open_price || '';
      this.newOrder.total_price = row.total_price || '';
      this.newOrder.startTime = row.startTime || '';
      this.newOrder.month = row.month || '';
      this.newOrder.stock_code = row.stock_code || '';
      this.newOrder.stock_name = row.stock_name || '';
      console.log(this.newOrder);
      this.editDialogVisible = true;
    },
    handleUpdate() {

      axios
        .put(`/api/orders/${this.newOrder.id}`, this.newOrder, {
          headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
        })
        .then(() => {
          this.$message.success('订单更新成功');
          this.fetchOrders();
          this.resetForm();
          this.editDialogVisible = false;
        })
        .catch((error) => {
          this.$message.error('订单更新失败');
          console.error('更新订单失败:', error);
        });
    },
    deleteOrder(index, row) {
      axios
        .delete(`/api/orders/${row.id}`, {
          headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
        })
        .then(() => {
          this.$message.success('订单删除成功');
          this.orders.splice(index, 1);
        })
        .catch((error) => {
          this.$message.error('订单删除失败');
          console.error('删除订单失败:', error);
        });
    },
     async fetchCustomers() {
      try {
        const res = await axios.get("/api/customers", {
          headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
          params: {
            page: this.currentPage,
            pageSize: this.pageSize
          }
        });
        this.users = res.data.data; // 当前页的数据
        this.total = res.data.total; // 总记录数
      } catch (error) {
        console.error("获取客户列表失败:", error);
        ElMessage.error("获取客户列表失败");
      }
    },

    resetForm() {
      this.newOrder = {
        orderNumber: '',
        orderContent: '',
        orderTime: '',
        sellPrice: 0.0,
        status: 0,
        customerId: '',
        options :'',
        id: '',
        uid: '',
        endTime: '',
        types: '',
        size: '',
        rate: '',
        open_price: '',
        total_price: '',
        startTime: '',
        month: '',
        stock_code: '',
        stock_name: '',
      };
      this.currentEditIndex = -1;
    },
  },
};
</script>
<style scoped>
.form-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.table-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.order-content {
  white-space: pre-line;
  word-break: break-all;
  padding: 8px;
}

.pagination-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.link-style {
  color: #409EFF;
  text-decoration: underline;
  cursor: pointer;
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
}

.styled-table th {
  background-color: #409EFF;
  color: #fff !important;
  font-weight: bold;
}

.styled-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  font-size: 14px;
  color: #333;
}

.el-button {
  margin-right: 10px;
}

.date-picker {
  width: 200px;
}

@media (max-width: 768px) {
  .form-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .form-container > * {
    margin-bottom: 10px;
  }
}


/* 添加按钮组样式 */
.el-button-group {
  display: flex;
  flex-wrap: nowrap;
}

.el-button-group .el-button {
  margin-right: 0;
  border-radius: 0;
}

.el-button-group .el-button:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.el-button-group .el-button:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  margin-right: 0;
}

/* 响应式处理 - 在小屏幕上堆叠按钮 */
@media (max-width: 1200px) {
  .el-table-column .el-button-group {
    flex-direction: column;
  }

  .el-button-group .el-button {
    border-radius: 0;
    border-bottom: none;
  }

  .el-button-group .el-button:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .el-button-group .el-button:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom: 1px solid #dcdfe6;
  }
}
</style>
